(ns frontend.test.entity-types.view
  (:require [common.localization :as loc]
            [common.schema.entity-types :as entity-types]
            [frontend.utils :as fu]))

(defn view
  []
  [:ul
   {:class "flex flex-col gap-4"}
   (->> entity-types/entities
        (sort-by (fn [[et _]]
                   (loc/tr et)))
        (map (fn [[entity-type metadata]]
               [:li
                {:class "flex flex-row gap-4"}
                [:i
                 {:class (fu/cs "fa" (:entity/icon metadata))}]
                [:span
                 {:class ""}
                 (loc/tr entity-type)]]))
        (doall))])
